<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </div>
          <h4 class="page-title">Terminal Management Config Audit Trail</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Terminal Configs</h4>
          <p class="sub-header">
            View Terminal Config Audit trail for your current participant
          </p>

          <div class="row">
            <div class="col-12">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0">
                <thead>
                  <tr>
                    <th>Terminal Config</th>
                    <th>Name</th>
                    <th class="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let merchant of terminalConfigs">

                    <td>{{ merchant.id }}</td>
                    <td>{{ merchant.name }}</td>
                    <td>
                      <button [style]="ViewButton" type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right" (click)="viewTerminalConfig(merchant)">
                        <i class="mdi mdi-pencil-box-outline"></i>
                        View
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div> <!-- end container -->
</div>
